import { render, staticRenderFns } from "./MtCollectsList.vue?vue&type=template&id=f74d58c8&scoped=true&"
import script from "./MtCollectsList.vue?vue&type=script&lang=js&"
export * from "./MtCollectsList.vue?vue&type=script&lang=js&"
import style0 from "./MtCollectsList.vue?vue&type=style&index=0&id=f74d58c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74d58c8",
  null
  
)

export default component.exports